<template>
    <div class="footer-wrap">
        <div class="footer">
            <div class="lin-top">
                <div class="logo">
                    <img class="logo-img" src="./images/logo.png" alt="Logo" @click="goIndex">
                    <div class="content">
                        <div class="content-text">
                            <img src="./images/call-icon.png" alt="Call Icon">
                            <div>
                                <p style="cursor: pointer;" @click="goContact">联系我们</p>
                                <p style="cursor: pointer;" @click="goPushEmail">欢迎投稿</p>
                                <p style="cursor: pointer;" @click="goSuggest">意见建议</p>
                            </div>
                        </div>
                        <div class="content-text">
                            <img src="./images/customer-server-icon.png" alt="Call Icon">
                            <div>
                                <p>客服支持</p>
                                <p>010-65596851</p>
                                <p>技术支持:010-65136884</p>
                                <p>销售服务:010-85112336，85118355</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="right">
                    <div class="btn-wrap">
                        <div @click="goAuthor" class="btn">作者专区</div>
                        <div @click="goVip" class="btn">会员服务</div>
                        <div @click="goHelp" class="btn">常见问题</div>
                        <div @click="goCompany" class="btn">关于我们</div>
                        <div @click="goHelp" class="btn">帮助中心</div>
                        <div @click="goSuggest" class="btn">意见反馈</div>
                    </div>
                    <div class="qr">
                        <img src="./images/qr.png" alt="QR Code">
                    </div>
                </div>
            </div>
            <div class="lin-middle">
                <span class="middle-span-1">
                    <span @click="goStatement">网站声明</span>
                    <span class="bar">|</span>
                    <span @click="goContact">联系我们</span>
                    <span class="bar">|</span>
                    <span @click="goSuggest">意见和建议</span>
                    <span class="bar">|</span>
                    <span @click="goEmail">总监信箱</span>
                </span>
                <span style="cursor:default;">Copyright©1998-{{ year }} DRCnet. All Rights Reserved 版权所有 国研网</span>
                <img style="vertical-align: text-bottom;margin-left: 18px;" src="./images/m-icon.png" alt="m icon">
            </div>
            <div class="lin-bottom">
                <span @click="goBook1">增值电信业务经营许可证 京ICP证030059号</span>
                <span @click="goBook2">网络出版服务许可证：网出证京字第420号</span>
                <span @click="goBook3">出版物经营许可证：新出发京零字第东230083号</span>
                <span @click="goBook4">增值电信业务经营许可证 京B2-20070136</span>
                <span @click="goBook5">京公网安备 11010102002958号 <img style="vertical-align: sub;"
                        src="@/assets/imgs/footer/filingForTheRecord.png" alt=""></span>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
export default {
    data() {
        return {
            year: ''
        };
    },
    created() {
        this.fetchTimeFromThirdParty();
    },
    methods: {
        async fetchTimeFromThirdParty() {
            try {
                // 发送GET请求到第三方时间服务API
                const response = await axios.get(
                    'https://report.drcnet.com.cn/reportapi/CommonController/common/getSystemLocationDate'
                );
                // 假设响应体中有一个`time`字段包含了时间信息
                // 你需要根据实际API的响应结构来调整这行代码
                let nowTime = new Date(response.data.data);
                const getYear = nowTime.getFullYear();
                this.year = getYear;
            } catch (error) {
                console.error('获取时间失败:', error);
                //失败之后重新调用
                // this.fetchTimeFromThirdParty();
                // 可以在这里处理错误，比如显示一个错误消息
                return false;
            }
        },
        goAuthor() {
            window.open('https://misc.drcnet.com.cn/DRCNet.Users.Web/Author/authorMain.aspx', "_blank")
        },
        goVip() {
            window.open('https://member.drcnet.com.cn/eDRCNet.Order.Web/Order/User/UserMain.aspx', "_blank")
        },
        goCompany() {
            window.open('https://company.drcnet.com.cn/about.html#/', "_blank")
        },
        goHelp(){
             window.open("https://www.drcnet.com.cn/help", "_blank")
        },
        
        goUseMV() {
            window.open("http://www.drcnet.com.cn/bayWindow/ProjectMV?title=教育版&url=http://misc.drcnet.com.cn/help/edunew.mp4", "_blank")
        },
        goSuggest() {
            window.open("https://misc.drcnet.com.cn/DRCNet.Users.Web/User/UserSuggestAdd1.aspx", "_blank")
        },
        goStatement() {
            window.open("https://www.drcnet.com.cn/statement", "_blank")
        },
        goContact() {
            window.open("https://company.drcnet.com.cn/lxwm.html#/contact", "_blank")
        },
        goEmail() {
            window.location.href = "mailto:chiefeditor@drcnet.com.cn";
        },
        goBook1() {
            window.open("https://beian.miit.gov.cn/#/Integrated/index", "_blank")
        },
        goBook2() {
            window.open("https://www.drcnet.com.cn/announcement/zizhiimg4", "_blank")
        },
        goBook3() {
            window.open("https://www.drcnet.com.cn/announcement/zizhiimg3", "_blank")
        },
         goBook4() {
            window.open("https://www.drcnet.com.cn/announcement/zizhiimg2", "_blank")
        },
        goBook5() {
            window.open("https://beian.mps.gov.cn/#/query/webSearch", "_blank")
        },
        goIndex(){
            window.open("https://www.drcnet.com.cn/#", "_blank")
        },
        goPushEmail(){
            // <a data-v-39d5a5bc="" href="">【投稿】</a>
            window.open("mailto:chiefeditor@drcnet.com.cn")
        }
    }
};
</script>

<style lang="less" scoped>
.footer-wrap {
    background: url(./images/footer-bg.png);
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;


    .footer {
        // max-width: 2168px;
        // margin: 0 auto;

        .lin-top {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 14px;
            justify-content: center;
            padding-top: 61px;
            padding-left: 82px;
            padding-right: 74px;

            .logo {
                display: flex;

                .logo-img {
                    margin-right: 69px;
                    width: 164px;
                    height: 54px;
                }

                .content {
                    display: flex;
                    gap: 53px;
                    border-left: 2px solid #3C74A7;
                    padding-left: 81px;

                    .content-text {
                        display: flex;
                        gap: 12px;

                        img {
                            width: 32px;
                            height: 32px;
                        }

                        p {
                            color: #DDECFC;
                            font-size: 14px;
                            line-height: 22px;
                        }
                    }
                }
            }

            .right {
                display: flex;
                justify-content: end;
                align-items: center;
                width: 100%;

                .qr {
                    img {
                        width: 120px;
                        height: 120px;
                    }
                }

                .btn-wrap {
                    display: grid;
                    grid-template-columns: repeat(2, 187px);
                    /* 2列，每列宽度187px */
                    grid-template-rows: repeat(3, 40px);
                    /* 3行，每行高度40px */
                    gap: 6px;
                    /* 行间距和列间距均为14px */
                    justify-content: center;
                    /* 水平居中（可选） */
                    margin-right: 91px;

                    div {
                        cursor: pointer;
                    }
                }

                .btn {
                    width: 187px;
                    height: 40px;
                    border: 1px solid #4F8CC8;
                    color: #DDECFC;
                    line-height: 40px;
                    text-align: center;
                }
            }


        }

        .lin-middle {
            margin-top: 56px;
            padding-left: 82px;
            padding-right: 74px;
            border-top: 1px solid #3C74A7;
            font-size: 14px;
            color: #BBCFE8;
            line-height: 48px;

            span {
                cursor: pointer;
            }

            .middle-span-1 {
                margin-right: 92px;

                .bar {
                    margin: 0 16px;
                    cursor: default;
                }
            }
        }

        .lin-bottom {
            padding-left: 82px;
            padding-right: 74px;
            border-top: 1px solid #3C74A7;
            font-size: 14px;
            color: #BBCFE8;
            line-height: 48px;

            span {
                margin-right: 16px;
                cursor: pointer;
            }
        }
    }
}

@media screen and (min-width: 770px) and (max-width: 1750px) {
    .lin-top {
        .logo {
            .content {
                display: block !important;

                .content-text {
                    &:first-child {
                        margin-bottom: 16px;
                    }
                }
            }
        }
    }
}

@media screen and (max-width: 769px) {

    .content-text,
    .logo,
    .lin-top,
    .btn-wrap {
        display: block !important;
    }

    .lin-top {
        padding: 16px !important;

        .logo {
            .content {
                border: none !important;
                padding: 0 !important;
                display: block !important;

                .content-text {
                    margin-bottom: 16px;

                    &:first-child {
                        div {
                            p {
                                display: inline-block;
                                margin-right: 8px;

                            }

                            vertical-align: sub !important;
                        }
                    }

                    img {
                        margin-right: 16px;
                    }

                    img,
                    div {
                        display: inline-block;
                        vertical-align: text-top;
                    }
                }
            }
        }

        .right {
            display: block !important;

            .btn-wrap {
                text-align: center;
                margin: 0 !important;
            }

            .btn {
                width: auto !important;
                display: inline-block;
                padding: 4px 20px;
                margin: 8px;
            }

            .qr {
                text-align: center;
            }
        }
    }

    .lin-middle {
        margin-top: 8px !important;
        padding: 16px !important;

        .middle-span-1 {
            margin-right: 0 !important;

            .bar {
                margin: 0 4px !important;
            }
        }
    }

    .lin-bottom {
        padding-left: 16px !important;
        padding-right: 16px !important;
    }
}
</style>